export enum ActionOrdersFilter {
    NoTimeslots,
    IncompleteActuals,
    Invoiced
}